/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
  auth: {
    //bcsoft
    // clientId:"b821a0d1-1c46-4b5d-a379-66ddafeb1497",
    // authority: "https://login.microsoftonline.com/bcsoft.net",
    //production
    // clientId: "78b1113c-1d53-48c7-996d-796d97299883",
    // authority:
    //   "https://login.microsoftonline.com/luxotticagroup.onmicrosoft.com",
    //QA
    clientId: "8d6952b8-2d68-48e1-a628-889b21ea82dd",
    authority:
      "https://login.microsoftonline.com/luxotticagroup.onmicrosoft.com",
    redirectUri: "/", // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
    postLogoutRedirectUri: "/", // Indicates the page to navigate after logout.
    navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
  },
  cache: {
    cacheLocation: "sessionStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            console.warn(message);
        }
      },
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: [],
};

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */

//qa
export const scopes = {
  scopes: [
    "api://6910486b-b864-4dd9-9ea9-5b4aea078fd2/Read",
    "api://6910486b-b864-4dd9-9ea9-5b4aea078fd2/Write",
  ], // e.g. api://xxxxxx/access_as_user
};
//Prod
// export const scopes = {
//     scopes: [
//       "api://c41f409a-2ddf-45b1-8e9a-5a2075107ee1/Read",
//       "api://c41f409a-2ddf-45b1-8e9a-5a2075107ee1/Write",
//     ], // e.g. api://xxxxxx/access_as_user
//   };
//Bcsoft
//export const scopes = {
//     scopes: ["api://ffd6cc5e-7c0d-4289-adc7-9aa0339acbce/Read","api://ffd6cc5e-7c0d-4289-adc7-9aa0339acbce/Write"], // e.g. api://xxxxxx/access_as_user

// }
